import { type CurrenciesKey } from 'src/core/config/money';
import { type ApprovalRule } from 'src/core/modules/company/structure/approval-flows';

export const defaultApprovalRules = (
  currency: CurrenciesKey,
): ApprovalRule[] => [
  {
    id: '1',
    from: {
      value: null,
      currency,
    },
    upTo: {
      value: null,
      currency,
    },
    steps: [
      {
        rights: [],
      },
    ],
  },
];
